<template>
  <div>
       <!-- <a id="tagOpenWin" target="_blank"></a> -->
    <div>
      <!-- <el-button
        type="success"
        size="mini"
        icon="el-icon-arrow-left"
        @click="goBack"
        style="background-color: #008a2c; float: left"
        >返回个人中心
      </el-button> -->
       <div   @click="goBack" style="cursor:pointer;color:#008A2C">
        <el-button type="info"  style="background-color:#008A2C;" icon="el-icon-back" circle></el-button> &nbsp;返回个人中心
     </div>
      <div class="f20 tc">武汉工商学院通知公告</div>
    </div>
    <el-divider></el-divider>
    <div
      style="min-height: 450px"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-row
        style="
          padding: 15px 10px 15px 20px;
          border-bottom: 1px dotted #ccc;
          cursor: pointer;
        "
        v-for="item in noticeData"
        :key="item.id"
        @click.native="toNoticeInfo(item.id)"
      >
        <el-col :span="20">
          <i
            class="el-icon-message-solid"
            style="
              float: left;
              padding: 3px 0;
              color: #008a2c;
              margin-right: 5px;
            "
          ></i>
          <p>{{ item.channelName }}：{{ item.newsTitle }}</p>
        </el-col>
        <el-col :span="4">
          <div class="flex-col h-center">
            {{ moment(item.deployTime).format("YYYY-MM-DD HH:mm:ss") }}
          </div>
        </el-col>
      </el-row>
    </div>
    <el-pagination
      style="margin: 20px"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="pageIndex"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { queryNotice, queryNoticeInfo } from "@/api/notice";
 
 

export default {
  name: "userCaseList",
  data() {
    return {
      userInfo: {},
      noticeData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      loading: true,
      ydmhtoken:''
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  mounted() {
      this.userInfo =this.getUserInfo
      console.log(this.$route)    
      this.ydmhtoken=this.$route.query.ydmhtoken
     // this.getYdmhToken()
    this.getNotice();
  },
  methods: {
    moment,

    async getNotice() {
      let searchData;
      // if(this.userInfo.userType=='1'){
      //    //老师
      
      //  let params = {
    
      //  userid: this.userInfo.userid,
      //   pageIndex: this.pageIndex,
      //   pageSize: this.pageSize,
      //   sortField: "createtime",
      //   sortOrder: "desc",
      // };
      //  console.log(this.ydmhtoken);
      // const data = await queryNoticeMoreUrl(params,this.ydmhtoken);
      // console.log(data);

      // if (data.msgCode == 0) {
      //     const aa = document.getElementById('tagOpenWin')
      //   const href =data.object.noticeMoreUrl
      //   aa.href = href
      //   aa.click()       
       
      //   this.loading = false;
        
      // }
      // }
      // if(this.userInfo.userType=='0'){
        //学生
     searchData = [
        {
         name: 'eq_newsChannelEntity.id',          
          value: "08c7e4faf1204170a5e2ba8831174075",
        },{
						name:'eq_datastatus',
						value:'1'
					}
      ];
       let params = {
        searchData: JSON.stringify(searchData),
        pageIndex: this.pageIndex-1,
        pageSize: this.pageSize,
        sortField: "createtime",
        sortOrder: "desc",
      };
       console.log(this.ydmhtoken);
      const data = await queryNotice(params,this.ydmhtoken);
      console.log(data);

      if (data.msgCode == 0) {
        this.noticeData = data.data;
        this.total = data.total;
        this.loading = false;
        console.log(this.loading);
      }
    //  }
     
     
    },
    async getNoticeInfo(id) {
      const data = await queryNoticeInfo(id);
      console.log(data);
      if (data.msgCode == 0) {
        window.open(data.data.source, "_blank");
      }
    },
    toNoticeInfo(id) {
      // this.$router.push('/userCenter/noticeInfo?id=' + id);
      this.getNoticeInfo(id);
    },
    goBack() {
      this.$router.push("/userCenter");
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getNotice();
    },
  },
};
</script>
<style>
</style>